var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-slider",class:{'is-visible': _vm.show }},[(_vm.show)?_c('div',{staticClass:"wrapper"},[_c('help'),_c('system-info')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }